// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExclamationOutlinedSvg from "@fishx/icons-svg/es/asn/ExclamationOutlined";
import FishxIcon from '../components/FishxIcon';

var ExclamationOutlined = function ExclamationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationOutlinedSvg
  }));
};

ExclamationOutlined.displayName = 'ExclamationOutlined';
export default React.forwardRef(ExclamationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExclamationOutlined.js
// module id = 2631
// module chunks = 0